import Yup from '@vizir-banking/banking-app-core/dist/utils/yup/yup';
import {requiredField} from '@vizir-banking/banking-app-core/dist/utils/validation-messages';

const schema = Yup.object({
  professionId: Yup.string().required(requiredField),
  monthlyIncome: Yup.string().noValue().required(requiredField),
});

export default schema;
